<template>
  <div id="evaluationScale">
    <v-content id="evaluationScaleTable">
      <h2>{{ $t("evaluation_scale") }}</h2>
      <v-row>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          md="2"
          lg="2"
          :class="{ active: easiResult <= 0 }"
          class="first inactive"
        >
          {{ $t("healed") }}
          <br />0
        </v-col>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          md="2"
          lg="2"
          :class="{ active: easiResult > 0 && easiResult <= 1 }"
          class="second inactive"
        >
          {{ $t("almost_healed") }}
          <br />0,1–1,0
        </v-col>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          md="2"
          lg="2"
          :class="{ active: easiResult > 1.1 && easiResult <= 7 }"
          class="third inactive"
        >
          {{ $t("moderate") }}
          <br />1,1–7,0
        </v-col>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          md="2"
          lg="2"
          :class="{ active: easiResult > 7.1 && easiResult <= 21 }"
          class="fourth inactive"
        >
          {{ $t("medium_AD") }}
          <br />7,1–21,0
        </v-col>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          lg="2"
          :class="{ active: easiResult > 21 && easiResult <= 50 }"
          class="fifth inactive"
        >
          {{ $t("severe_AD") }}
          <br />21,1–50,0
        </v-col>
        <v-col
          :cols="printPage ? 2 : 4"
          sm="2"
          lg="2"
          :class="{ active: easiResult > 50 && easiResult <= 71 }"
          class="sixth inactive"
        >
          {{ $t("very_severe_AD") }}
          <br />50,1–72
        </v-col>
      </v-row>
    </v-content>
  </div>
</template>

<script>
export default {
  props: ["easiResult", "easiResultLabel"],
  data() {
    return {
      ticksLabels: [
        "0 Zhojen",
        "0,1–1 Téměř zhojen",
        "1,1–7 Mírná",
        "7,1–21 Středně těžká",
        "21,1–50 Těžká",
        "50,1–72 Velmi těžká"
      ],
      evaluationScaleResult: 0
    };
  },
  computed: {
    printPage() {
      return this.$store.getters.getPrintPage;
    }
  },
  watch: {
    easiResult: function(val) {
      this.easiResult = val;
      if (val <= 0) {
        this.$emit("update:easi-result-label", this.$t("healed"));
      } else if (val > 0 && val <= 1) {
        this.$emit("update:easi-result-label", this.$t("almost_healed"));
      } else if (val > 1.1 && val <= 7) {
        this.$emit("update:easi-result-label", this.$t("moderate"));
      } else if (val > 7.1 && val <= 21) {
        this.$emit("update:easi-result-label", this.$t("medium"));
      } else if (val > 21 && val <= 50) {
        this.$emit("update:easi-result-label", this.$t("sevete"));
      } else {
        this.$emit("update:easi-result-label", this.$t("very_severe"));
      }
    }
  }
};
</script>
<style scoped lang="scss">
h2 {
  margin-bottom: 1em;
}
.active.first {
  background-color: #00b816;
  color: white;
  font-weight: bold;
}
.active.second {
  background-color: #75d981;
  color: rgb(70, 70, 70);
  font-weight: bold;
}
.active.third {
  background-color: #ffe699;
  color: rgb(70, 70, 70);
  font-weight: bold;
}
.active.fourth {
  background-color: #ffc000;
  color: rgb(70, 70, 70);
  font-weight: bold;
}
.active.fifth {
  background-color: #ed7d31;
  color: rgb(70, 70, 70);
  font-weight: bold;
}
.active.sixth {
  background-color: #ff0000;
  color: white;
  font-weight: bold;
}

#evaluationScaleTable {
  width: 100%;
}
.row {
  margin: auto;
  div {
    width: 16%;
    text-align: center;
    background-color: #dcdcdc;
    color: gray;
    padding: 10px;
    border: 1px solid white;
  }
}
.theme--light.v-data-table thead tr:last-child th {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.theme--light.v-data-table thead tr th {
  color: rgb(192, 192, 192);
}
#evaluationScale {
  margin-top: 2em;
}
</style>
